import '@styles/views/csc.less';
/* import AppBannerCSC from '@components/app/appBannerCSC'; */
//import AppAdvantage from '@components/app/appAdvantage';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
import AppFooter from '@components/app/appFooter';
import AppNewThree from '@/components/app/appNewThree';

const NewThree = () => {
  return (
    <div className={'introduce-page'}>
      {/* <AppBannerCSC /> */}
      <AppNewThree />
      <AppFooter />
    </div>
  );
};

export default NewThree;
